import axios from 'axios'

const showDeptBalanceOrders = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}systemUsers/balanceOrderByDebt`,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    return response.data.data
  } catch (error) {}
}

export default showDeptBalanceOrders
